// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.co-deadline {
  display: flex;
  align-items: center;
  gap: 9px;
}

.co-deadline .f-input {
  flex: 1 1;
}

.co-deadline span {
  font-size: 0.9rem;
  color: var(--muted);
}

.co-files {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.co-files li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
}

.co-file-name {
  flex: 1 1;
  min-width: 0;
  font-size: 0.85rem;
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.co-files button {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted2);
  cursor: pointer;
}

.co-files button:hover {
  background: var(--danger-50);
  color: var(--danger);
}
`, "",{"version":3,"sources":["webpack://./src/app/client/CreateOrder.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB","sourcesContent":[".co-deadline {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.co-deadline .f-input {\n  flex: 1;\n}\n\n.co-deadline span {\n  font-size: 0.9rem;\n  color: var(--muted);\n}\n\n.co-files {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.co-files li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n}\n\n.co-file-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.85rem;\n  color: var(--text-soft);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.co-files button {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--muted2);\n  cursor: pointer;\n}\n\n.co-files button:hover {\n  background: var(--danger-50);\n  color: var(--danger);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
